function stringToArray(list: String) : number[]{
    return removeNonAlphabet(list).split(" ").map(x => +x);
}

function removeNonAlphabet(list: String) : String{
    return list.replace(/\D/g, ' ').replace(/  +/g, ' ').trim();
}

export{
    stringToArray
}